module.exports = __webpack_public_path__ + "static/media/diagnoses_selected.cd563706.svg";